import React, { useState } from 'react';
import { Sidebar } from '../components/Sidebar';
import {CodeSpace} from "../components/CodeSpace.tsx";
export function CodeSpacePage() {

    return (
        <div className="flex min-h-screen">
            <Sidebar />
            <CodeSpace />
        </div>
    );
}